export default __webpack_public_path__ + "static/media/youtube.fc5563a7.png";